import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation } from "react-query";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";

const useDownloadEquipmentExportCsvMutation = () => {
    const alert = useAlert();
    const accessToken = useAccessToken();

    return useMutation({
        mutationFn: async (): Promise<void> => {
            const response = await fetch(
                `${BACKEND_DOMAIN}/buildings/equipment_export`,
                { headers: buildRequestHeaders(accessToken) }
            );

            if (!response.ok) {
                let message = `Error ${response.status}`;
                const contentType = response.headers.get("content-type") || "";
                if (contentType.includes("application/json")) {
                    try {
                        const body = await response.json();
                        if (typeof body?.error === "string") message = body.error;
                    } catch {
                        // use default message
                    }
                }
                throw new Error(message);
            }

            const disposition = response.headers.get("Content-Disposition") ?? "";
            const match = disposition.match(/filename=([^;]+)/);
            const filename = match ? match[1].trim() : `equipment_export.csv`;

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(url);
        },
        onError: (error) => {
            const message = error instanceof Error ? error.message : String(error);
            showMutationAlert(message, alert);
        },
    });
};

export default useDownloadEquipmentExportCsvMutation;
